import React, { useState } from 'react';
import { FaRegCompass } from 'react-icons/fa';
import moment from 'moment';

const CompassWithPopup = ({ shortCloseInitiatedDetails, isVendor, loggedInUserEmail }) => {
  const [showPopup, setShowPopup] = useState(false);

  const handleTogglePopup = () => setShowPopup((prev) => !prev);
  const handleClosePopup = () => setShowPopup(false);

  return (
    <div className="relative w-1/5 justify-end items-center block">
      <span title="History" className="cursor-pointer">
        <FaRegCompass
          size={18}
          className="text-[#565FBB]"
          onClick={handleTogglePopup}
        />
      </span>

      {showPopup && (
        <>
          <div
            className="backdrop opacity-90 transition-opacity duration-200 fixed inset-0 z-40"
            onClick={handleClosePopup}
          />
          <div className="absolute top-6 right-0 w-96 bg-white shadow-2xl rounded-lg p-4 z-50 text-sm mt-4 mb-3 text-left">
            {shortCloseInitiatedDetails?.approvers
              ?.filter(({ approver }) => {
                if (!isVendor) return true;
                return approver?.email === loggedInUserEmail;
              })
              ?.map((approver, index) => {
              const { approver: person, status, level, requestDate, approvalDate } = approver;
              const statusClass = status === 'Approved'
                ? 'status-approved'
                : status === 'Rejected'
                  ? 'status-rejected'
                  : 'status-pending';

              const statusDate = status === 'Approved' || status === 'Rejected'
                ? approvalDate
                : requestDate;

              return (
                <div className="mt-3">
                  <div key={person?.id || index} className="grid grid-cols-2-2-1 gap-3 mb-3">
                    <div className="min-w-0">
                      <div className="font-semibold text-black email-ellipsis" title={person?.name || '-'}>{person?.name || '-'}</div>
                      <div className="text-xs text-gray-500 email-ellipsis" title={person?.email || '-'}>
                        {person?.email || '-'}
                      </div>
                    </div>
                    <div className="pt-1 min-w-0 pl-1">
                      <div className="text-xs text-gray-600">
                        Level
                        <span className="pl-1">{level}</span>
                      </div>
                      <div className="text-xs text-gray-600 mt-1">
                        {requestDate ? moment(statusDate).format('DD-MM-YYYY, hh:mm A') : '-'}
                      </div>
                    </div>
                    <div className="text-right min-w-0">
                      <div className={statusClass}>
                        {status || '-'}
                      </div>
                    </div>
                  </div>
                  <hr className="border-gray-300" />
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default CompassWithPopup;
